import axios from "../../../lib/axios";

export const signupsByMonth = async () => {
  try {
    return await axios.get(`/reports/signupsByMonth`);
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const userCountPerCharacterCount = async () => {
  try {
    return await axios.get(`/reports/userCountPerCharacterCount`);
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};

export const characterCountByRuleset = async () => {
  try {
    return await axios.get(`/reports/characterCountByRuleset`);
  } catch (err) {
    console.error(err.response);
    throw err;
  }
};
